import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthService } from '../services/auth.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private auth: AuthService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        const currentUser = this.auth.getUser();
        if (currentUser['value'] && currentUser['value']['token']) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${currentUser['value']['token']}`
                }
            });
        }

        return next.handle(request);
    }
}
